module.exports = __webpack_public_path__ + "img/Mic_to_G.57cfe086.gif";